import React, { useContext } from 'react';

import { ThemeContext } from '../../contexts/ThemeContext';

import './Education.css'
import EducationCard from './EducationCard';

import { educationData } from '../../data/educationData'
import { DataContext } from '../../contexts/DataContext';

function Education() {

    const { theme } = useContext(ThemeContext);
    const { data } = useContext(DataContext)
    return (
        <div className="education" id="resume" style={{ backgroundColor: theme.secondary }}>

            <div className="education-body">
                <div className="education-description">
                    <h1 style={{ color: theme.primary }}>Education</h1>
                    {(data.education.length !== 0 ? data.education : educationData).map(edu => (
                        <EducationCard
                            key={edu.id}
                            id={edu.id}
                            institution={edu.institution}
                            course={edu.course}
                            startYear={edu.startYear}
                            endYear={edu.endYear}
                        />
                    ))}
                </div>
                <div className="education-image">
                    <img src={theme.eduimg} alt="" />
                </div>
            </div>
        </div>
    )
}

export default Education
